import {
  applyStatusAtom,
  pipelineErrorAtom,
  prepareStatusAtom,
  processStatusAtom,
} from './atoms'

import { getPipelineStatus } from './utils'
import { useAtom } from 'infrastructure/state/jotai.wrapper'
import { useCallback } from 'react'

export function usePipelineStatusPolling() {
  const [, setPrepareStatus] = useAtom(prepareStatusAtom)
  const [, setProcessStatus] = useAtom(processStatusAtom)
  const [, setApplyStatus] = useAtom(applyStatusAtom)
  const [, setPipelineError] = useAtom(pipelineErrorAtom)

  const checkStatus = useCallback(
    (treeId: string, versionId: string) => {
      let intervalId: NodeJS.Timeout | null = null

      const pollStatus = async () => {
        try {
          const response = await getPipelineStatus(treeId, versionId)
          if (response?.data) {
            // Update individual stage statuses based on the response
            // This would need to be adapted based on the actual API response structure
            if (response.data.prepare) {
              setPrepareStatus(response.data.prepare)
            }
            if (response.data.process) {
              setProcessStatus(response.data.process)
            }
            if (response.data.update) {
              setApplyStatus(response.data.update)
            }
          }
        } catch (error) {
          setPipelineError(
            `Error checking pipeline status: ${error instanceof Error ? error.message : 'Unknown error'}`,
          )
        }
      }

      // Start polling immediately
      pollStatus()

      // Set up interval for continued polling
      intervalId = setInterval(pollStatus, 5000) // Poll every 5 seconds

      // Return cleanup function
      return () => {
        if (intervalId) {
          clearInterval(intervalId)
        }
      }
    },
    [setPrepareStatus, setProcessStatus, setApplyStatus, setPipelineError],
  )

  return checkStatus
}
